// api.js
const BASE_URL = "http://127.0.0.1:8000";



export async function getVisits(status) {
  const res = await fetch('https://64rt4awzn3.execute-api.us-east-1.amazonaws.com/dev/getappointment', {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: "{\"date\":\"2026-08-15\",\"period\":\"week\"}",
  });
  if (!res.ok) throw new Error("Failed to reject visit");
  return res.json();
}

export async function doctor_login(email,password) {
  let postdata = {
    "email":email,
    "password":password
  };
  const res = await fetch('https://64rt4awzn3.execute-api.us-east-1.amazonaws.com/dev/doctorlogin', {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(postdata),
  });
  if (!res.ok) throw new Error("Authentication failed");
  return res.json();
}

export async function getVisitById(visitId) {
  const res = await fetch(`${BASE_URL}/visits/${visitId}`);
  if (!res.ok) throw new Error("Failed to fetch visit");
  return res.json();
}

export async function saveDraft(visitId, edits) {
  const res = await fetch(`${BASE_URL}/visits/${visitId}/draft`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(edits),
  });
  if (!res.ok) throw new Error("Failed to save draft");
  return res.json();
}

export async function approveVisit(visitId) {
  const res = await fetch(`${BASE_URL}/visits/${visitId}/approve`, { method: "POST" });
  if (!res.ok) throw new Error("Failed to approve visit");
  return res.json();
}

export async function rejectVisit(visitId, notes) {
  const res = await fetch(`${BASE_URL}/visits/${visitId}/reject`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(notes),
  });
  if (!res.ok) throw new Error("Failed to reject visit");
  return res.json();
}

export async function getAuditTrail(visitId) {
  const res = await fetch(`${BASE_URL}/visits/${visitId}/audit`);
  if (!res.ok) throw new Error("Failed to fetch audit trail");
  return res.json();
}

export async function createTranscriptUpload({ appointmentId, recordedAt }) {
  const res = await fetch("https://64rt4awzn3.execute-api.us-east-1.amazonaws.com/dev/transcript", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ appointmentId, recordedAt }),
  });
  if (!res.ok) throw new Error("Failed to get upload URL");
  return res.json();
}

export async function getTranscriptsByAppointmentId(appointmentId) {
  const res = await fetch("https://64rt4awzn3.execute-api.us-east-1.amazonaws.com/dev/appointment-transcripts/"+appointmentId, {
    method: "GET",
    headers: { "Content-Type": "application/json" }
  });
  if (!res.ok) throw new Error("Failed to get upload URL");
  return res.json();
}

export async function uploadRecordingToS3(presignedURL, blob) {
  const res = await fetch(presignedURL, {
    method: "PUT",
    body: blob,
    headers: { "Content-Type": "audio/wav" },
  });
  if (!res.ok) throw new Error("Upload failed");
}
